import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {   IndividualRelationCreateRequestDTO,
    IndividualRelationUpdateRequestDTO,
    IndividualRelationDeleteRequestDTO,
    IndividualRelationReadByIdRequestDTO,
    IndividualRelationReadByIndividualIdRequestDTO,
    IndividualRelationDTO,
    IndividualRelationList
} from './individualRelation.interface';

import {
  IndividualRelation_create,
  IndividualRelation_update,
  IndividualRelation_delete,
  IndividualRelation_readById,
  IndividualRelation_readByIndId,
  IndividualRelation_readAll
} from 'src/app/GlobalVariables';


@Injectable({
  providedIn: 'root'
})
export class IndividualRelationService {

  http = inject(HttpClient);

  constructor() {}

  IndividualRelation_create(data: IndividualRelationCreateRequestDTO): Observable<IndividualRelationDTO> {
    return this.http.post<IndividualRelationDTO>(IndividualRelation_create, data);
  }

  IndividualRelation_update(data: IndividualRelationUpdateRequestDTO): Observable<IndividualRelationDTO> {
    return this.http.post<IndividualRelationDTO>(IndividualRelation_update, data);
  }

  IndividualRelation_delete(data: IndividualRelationDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(IndividualRelation_delete, data);
  }

  IndividualRelation_readById(data: IndividualRelationReadByIdRequestDTO): Observable<IndividualRelationDTO> {
    return this.http.post<IndividualRelationDTO>(IndividualRelation_readById, data);
  }

  IndividualRelation_readByIndId(data: IndividualRelationReadByIndividualIdRequestDTO): Observable<IndividualRelationList> {
    return this.http.post<IndividualRelationList>(IndividualRelation_readByIndId, data);
  }

  IndividualRelation_readAll(): Observable<IndividualRelationList> {
    return this.http.get<IndividualRelationList>(IndividualRelation_readAll);
  }
}
